import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { ChevronDown, ChevronUp, Check } from "lucide-react";

export const VehicleFeatureGroup = ({
  category,
  selectedFeatures = {},
  onToggleFeature,
  defaultExpanded = false,
}) => {
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState(defaultExpanded);

  const categoryKey = `vehicleFeatures.category_${category.id}`;
  const translatedTitle = t(categoryKey);
  const categoryTitle =
    translatedTitle && translatedTitle !== categoryKey
      ? translatedTitle
      : category.title;

  return (
    <div className="w-full bg-white rounded-xl border border-gray-200 overflow-hidden mb-2.5 transition-all">
      {/* Category Accordion Header */}
      <button
        type="button"
        onClick={() => setExpanded(!expanded)}
        className="w-full flex items-center justify-between px-4 py-3.5 bg-white hover:bg-gray-50/80 text-left transition-colors"
      >
        <span className="text-sm font-semibold text-gray-900">
          {categoryTitle}
        </span>
        <div className="text-gray-400">
          {expanded ? (
            <ChevronUp className="w-4 h-4" />
          ) : (
            <ChevronDown className="w-4 h-4" />
          )}
        </div>
      </button>

      {/* Feature Items List */}
      {expanded && (
        <div className="border-t border-gray-100 divide-y divide-gray-100 bg-[#FCFCFD]">
          {category.items.map((item) => {
            const isChecked = !!selectedFeatures[item.key];
            const itemKey = `vehicleFeatures.${item.key}`;
            const translatedItemLabel = t(itemKey);
            const itemLabel =
              translatedItemLabel && translatedItemLabel !== itemKey
                ? translatedItemLabel
                : item.label;

            return (
              <button
                key={item.key}
                type="button"
                onClick={() => onToggleFeature(item.key)}
                className="w-full flex items-center justify-between px-4 py-3 hover:bg-gray-100/60 transition-colors text-left group"
              >
                <span
                  className={`text-xs sm:text-sm transition-colors ${
                    isChecked
                      ? "font-semibold text-gray-900"
                      : "text-gray-600 font-normal group-hover:text-gray-800"
                  }`}
                >
                  {itemLabel}
                </span>

                {/* Custom Checkbox */}
                <div
                  className={`w-5 h-5 rounded-md border flex items-center justify-center transition-all flex-shrink-0 ml-3 ${
                    isChecked
                      ? "bg-[#0B0E39] border-[#0B0E39] text-white"
                      : "border-gray-300 bg-white"
                  }`}
                >
                  {isChecked && <Check className="w-3.5 h-3.5 stroke-[2.5]" />}
                </div>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};
